import React from 'react';
import HomeHeroCarousel from '../components/HomeHeroCarousel';
import RecommendedPlants from '../components/plants/RecommendedPlants';
import GardenCollections from '../components/GardenCollections';
import Features from '../components/Features';
import HomeTools from '../components/HomeTools';
import FeaturedPosts from '../components/blog/FeaturedPosts';
import Footer from '../components/Footer';
import { useAuth } from '../hooks/useAuth';
import { useGrowingZone } from '../hooks/useGrowingZone';

export default function Home() {
  const { user } = useAuth();
  const { zone } = useGrowingZone();

  return (
    <div>
      <HomeHeroCarousel />
      
      {/* Content sections without ads */}
      <Features />
      <HomeTools />
      <FeaturedPosts />
      <GardenCollections />
      
      {(user || zone) && <RecommendedPlants />}
      
      {/* Footer */}
      <Footer />
    </div>
  );
}